import React, { useRef, useState, useEffect } from "react";

import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import EmailIcon from "@mui/icons-material/Email";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import Snackbar from "@mui/material/Snackbar";
import LogoGeosoftsolutions from "../assets/LogoGeosoftsolutions.png";

import { passwordOlvidado } from "../service/apiService";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

function ResetPassword() {
  //react-router-doom
  const navigate = useNavigate();
  
  //react-hook-form
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  //snackbar de alertas
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
  });

  //cierra el snackbar
  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };

  //envia el email para generar token
  const onSubmit = async (data) => {
    const response = await passwordOlvidado(data);
    setSnackbar({ message: response?.message, open: true });
  };

  //action snackbar
  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" className="text-amarillo" />
      </IconButton>
    </React.Fragment>
  );

  //estilo del input
  const inputStyle = {
    //input
    input: {
      color: "#fffcfc",
      "::placeholder": {
        color: "#fffcfc",
        opacity: 1,
      },
    },
    //label
    label: {
      color: "#fffcfc",
    },
    //focus
    "& label.Mui-focused": {
      color: "#fffcfc",
    },

    //color para los errores
    "& .Mui-error": {
      color: "#cb9636",
    },
    "& label.Mui-error": {
      color: "#cb9636",
    },
    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
      borderColor: "#cb9636",
    },
    "& .MuiFormHelperText-root.Mui-error": {
      color: "#cb9636",
    },

    // combate el autofill de los navegadores
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#7b7f89",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#d4d4d8",
      },
      // combate el autofill
      "& input:-webkit-autofill": {
        boxShadow: "0 0 0 1000px #393b40 inset",
        WebkitTextFillColor: "#fffcfc",
        caretColor: "#fffcfc",
        transition: "background-color 5000s ease-in-out 0s",
      },
    },
  };

  //estilo del button
  const styleButton = {
    backgroundColor: "#cb9636",
    color: "#1e1e28",
    "&:hover": {
      backgroundColor: "#fcd488",
    },
    marginTop: "15px",
    display: "block",
    mx: "auto",
    width: "150px",
    height: "32px",
  };

  //estilo del button regresar
  const styleButton2 = {
    backgroundColor: "#484d50",
    color: "#cb9636",
    "&:hover": {
      backgroundColor: "#555b5e",
    },
    marginTop: "15px",
    display: "block",
    mx: "auto",
    width: "150px",
    height: "32px",
  };

  return (
    <section className="bg-fondo_blanco shadow-xl rounded-lg">
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleClose}
        message={snackbar.message}
        action={action}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        ContentProps={{
          sx: {
            color: "#fffcfc"
          },
        }}
      />

      <div className="min-h-[calc(82vh)] flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
        <div className="w-full rounded-lg shadow-xl md:mt-0 sm:max-w-md xl:p-0 bg-ceniza_light border-gray-700">
          <div className="p-6 space-y-4 md:space-y-4 sm:p-4">
            <img
              className="w-[220px] h-auto mx-auto"
              src={LogoGeosoftsolutions}
              alt="logo"
            />

            <h1 className="text-xl font-bold leading-tight tracking-tight md:text-2xl text-blanco text-center">
              ¿Ha olvidado su contraseña?
            </h1>

            <form
              className="space-y-4 md:space-y-6"
              onSubmit={handleSubmit(onSubmit)}
            >
              <div className="rounded-lg block w-full bg-inputs border border-gray-700 shadow-lg p-3 flex">
                <ErrorIcon
                  fontSize="medium"
                  className="text-amarillo mt-5 mr-3"
                />
                <p className="text-blanco text-[12px] text-justify">
                  No se preocupe, le puede ocurrir a cualquiera. Simplemente
                  introduzca su dirección de correo electrónico, haga clic en
                  Siguiente y le enviaremos a su correo electrónico un enlace
                  para restablecer la contraseña.
                </p>
              </div>

              <TextField
                required
                id="email"
                label="Correo"
                defaultValue=""
                className="mt-2 rounded-lg block w-full bg-inputs border"
                sx={inputStyle}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon className="text-amarillo" fontSize="10" />
                      </InputAdornment>
                    ),
                  },
                }}
                error={!!errors.email}
                helperText={errors.email ? "Campo faltante  o inválido" : ""}
                {...register("email", {
                  required: true,
                  pattern: /^\S+@\S+$/i,
                })}
              />

              <div className="flex flex-row gap-2 ">
                <Button
                  onClick={() => navigate("/login")}
                  role={undefined}
                  variant="contained"
                  sx={styleButton2}
                >
                  Regresar
                </Button>

                <Button
                  type="submit"
                  role={undefined}
                  variant="contained"
                  sx={styleButton}
                >
                  Siguiente
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ResetPassword;
